import React from "react";
import { ApolloProvider } from "@apollo/client";
import { CurrentUserContextProvider } from "contexts/CurrentUserContext";
import FeatureFlagBridge from "frontend/context/FeatureFlagBridge";
import client from "../../helpers/apollo-client";

import AiOptOutSection from "frontend/components/creator-dashboard/icons/ai-opt-out/AiOptOutSection";

export default function AiOptOutWrapper() {
    return (
        <ApolloProvider client={client}>
            <CurrentUserContextProvider>
                <FeatureFlagBridge>
                    <AiOptOutSection />
                </FeatureFlagBridge>
            </CurrentUserContextProvider>
        </ApolloProvider>
    );
}
